import type { VectorCustomization } from '@yandex/ymaps3-types';

export const mapCustomization: VectorCustomization = [
  {
    tags: {
      any: ['poi'], // Все точки интереса имеют чб маркеры
    },
    stylers: [
      {
        saturation: -1,
      },
    ],
  },
  {
    tags: {
      any: ['cemetery'], // не показываем кладбища на тайлах карты
    },
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    tags: {
      any: ['commercial_services'], // не показываем отели (и другие бизнесы) на тайлах карты
    },
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    tags: {
      any: ['transit_stop'], // Все точки интереса имеют чб маркеры
    },
    stylers: [
      {
        scale: 0.7,
      },
    ],
  },
];
